export default __webpack_public_path__ + "static/media/spinning.54ce6236.webp";